import { HttpClient } from '../../httpClient'
import type { OpalApiResponseDocument, OpalApiRequestBody } from '../../schema'

export type CreateBoardObjectV3ResponseData = OpalApiResponseDocument<
  'CreateBoardObjectV3',
  201
>

export function createBoardObject(
  requestBody: OpalApiRequestBody<'CreateBoardObjectV3'>
) {
  return HttpClient()
    .post<CreateBoardObjectV3ResponseData>('/board_objects/v3', requestBody)
    .then((res) => res.data)
}
